// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Bm94","label":"SetPasswdForm_label__2Spkb"};